module.exports = __webpack_public_path__ + "static/media/17.249c2d2c.wav";